export enum InputEnums   {
    LEFT='LEFT',
    RIGHT='RIGHT'
} 

